import { AssemblyOrder } from './assembly-order.model';
import { Client } from '.';

export class Workplan {
  id?: string;
  name: string;
  description: string;
  isActive: boolean;
  status?: string;
  startDate: string;
  assemblyOrders?: AssemblyOrder[];
  shiftsBetweenMachines: number;
  finishedAssemblyOrders?: AssemblyOrder[];
  finished?: boolean;
  finishedDate?: string;

  constructor(workplan) {
    if (workplan.id) { this.id = workplan.id; }
    this.name = workplan.name;
    this.description = workplan.description;
    this.isActive = workplan.isActive;
    this.status = workplan.isActive ? 'activo' : 'inactivo';
    this.startDate = workplan.startDate;
    if (workplan.assemblyOrders) { this.assemblyOrders = workplan.assemblyOrders.map(order => new AssemblyOrder(order)); }
    if (workplan.finishedAssemblyOrders) {
      this.finishedAssemblyOrders = workplan.finishedAssemblyOrders.map(order => new AssemblyOrder(order));
    }
    this.shiftsBetweenMachines = workplan.shiftsBetweenMachines;
    if (workplan.finished) { this.finished = workplan.finished;}
    if (workplan.finishedDate) {this.finishedDate = workplan.finishedDate;}
  }
}
